<template>
  <div class="contract-selectScheme-dialog">
    <custom-dialog width="900px" :title="model.title" :visible="visible"  v-on="$listeners" >
      <div class="dialog-body">
        <!-- 表格 -->
        <div class="product-wrap">
          <div class="table-bd">
            <custom-table
              ref="table"
              type="checkbox"
              :data="schemeList"
              @input="selectionChange($event, 'schemeSelect')"
              :loading="isLoading"
              :column="tableColumn"
              @filter="filterChange"
              @sort="sortChange"
              height="500px"
            >
            </custom-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{
         $t('Common.com_cancel')
        }}</el-button>
        <el-button type="primary" @click="saveChoose">{{
         $t('Common.com_confirm')
        }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';

import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableCode: 'contract_scheme',
      schemeList: [],
      isLoading: false,
      schemeSelect: [],
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.initDialog();
    this.getLessee();
    this.getTableColumn();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 获取关联列表
    getLessee: function () {
      this.isLoading = true;
      this.$getJSON(apis.crmContractListScheme, { bizId: this.model.contractId, bizClass: this.model.contractClass }).then(
        (res) => {
          this.isLoading = false;
          this.schemeList = res.data.goodsList ? res.data.goodsList : [];
        }
      );
    },

    // 表格选中变更
    selectionChange: function (val, name) {
      // if (val.length > 1) {
      //   this.$refs.table.$refs.tb1.clearSelection();
      //   const select = val.pop();
      //   this.$refs.table.$refs.tb1.toggleRowSelection(select);
      //   this[name] = [select];
      //   // this.name = [];
      //   // this[name] = val;
      // } else {
      //   // this.name = [];
      //   this[name] = val;
      // }
      this[name] = val;
    },


    // 保存新增
    saveChoose: function () {
      if (!this.schemeSelect.length) {
        this.$message({
          message: this.$t('crm_contract_selectScheme_dialog.qing_xuan_ze_fang_an'),
          type: 'error',
        });
      } else {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success', this.schemeSelect);
        this.closeDialog();
      }
    },
  },
};
</script>

<style lang="scss">
.contract-selectScheme-dialog {
  .search-container {
    padding: 0px 8px 8px;
    margin-bottom: 16px;
    background: #f6f6fa;
    border-radius: 2px;
    overflow: hidden;
    // overflow: hidden;
    .el-form-item {
      // width: 14.2%;
      width: 16.6%;
      margin: 0 !important;
      margin-bottom: 0px !important;
      padding: 0 8px;
      .el-input__inner {
        border: none !important;
      }
    }
    > .advanced-footer {
      overflow: hidden;
      margin-top: 10px;
      .button-group {
        margin-right: 8px;
        margin-bottom: 8px;
        margin-top: 8px;
        float: right;
      }
    }
    .el-input-group__prepend {
      background-color: #ffffff;
      border: none;
      .el-select {
        vertical-align: baseline !important;
      }
    }

    .el-input.is-disabled .el-input__inner {
      background-color: #fcfcfc;
    }

    .el-form-item--small .el-form-item__label {
      margin-top: 16px;
      font-size: 12px;
      padding: 0px 0px 4px 0 !important;
      color: #495057;
      line-height: 24px;
    }
  }
}
</style>
